import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosNewApiInstance } from "../../services/api.js";

// Get all warehouses with details +
export const getAllWarehousesWithDetails = createAsyncThunk(
  "warehouse/getAllWarehousesWithDetails",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/wms/warehouses/tree`
      );

      console.log("getAllWarehousesWithDetails:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get all warehouses with all parts +
export const getAllWarehousesWithAllParts = createAsyncThunk(
  "warehouse/getAllWarehousesWithAllParts",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/wms/warehouses/full_tree`
      );
      console.log("getAllWarehousesWithAllParts:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Crete Warehouse +
export const createWarehouse = createAsyncThunk(
  "warehouse/createWarehouse",
  async (warehouseData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/wms/warehouses/`,
        warehouseData
      );
      console.log("createWarehouse", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update warehouse +
export const updateWarehouse = createAsyncThunk(
  "warehouse/updateWarehouse",
  async (updateData, thunkAPI) => {
    const { warehouse_id, fields } = updateData;
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/wms/warehouses/${warehouse_id}`,
        fields
      );
      console.log("updateWarehouse", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete warehouse +
export const deleteWarehouse = createAsyncThunk(
  "warehouse/deleteWarehouse",
  async (warehouseId, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/wms/warehouses/${warehouseId}`
      );
      console.log("deleteWarehouse", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create section+
export const createSection = createAsyncThunk(
  "warehouse/createSection",
  async (createSectionData, thunkAPI) => {
    const { count, ...sectionData } = createSectionData;
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/wms/sections/?count=${count}`,
        sectionData
      );
      console.log("createSection", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update section +
export const updateSection = createAsyncThunk(
  "warehouse/updateSection",
  async (updateData, thunkAPI) => {
    const { id, ...dataToUpdate } = updateData;
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/wms/sections/${id}`,
        dataToUpdate
      );
      console.log("updateSection", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete section +
export const deleteSection = createAsyncThunk(
  "warehouse/deleteSection",
  async (sectionId, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/wms/sections/${sectionId}`
      );
      console.log("deleteSection", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create racks +
export const createRacks = createAsyncThunk(
  "warehouse/createRacks",
  async (createRacksData, thunkAPI) => {
    const { count, ...rackData } = createRacksData;
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/wms/racks/?count=${count}`,
        rackData
      );
      console.log("createRacks", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update rack +
export const updateRack = createAsyncThunk(
  "warehouse/updateRack",
  async (updateData, thunkAPI) => {
    const { id, ...dataToUpdate } = updateData;
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/wms/racks/${id}`,
        dataToUpdate
      );
      console.log("updateRack", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete rack +
export const deleteRack = createAsyncThunk(
  "warehouse/deleteRack",
  async (rackId, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/wms/racks/${rackId}`
      );
      console.log("deleteRack", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create shelves +
export const createShelves = createAsyncThunk(
  "warehouse/createShelves",
  async (createShelfData, thunkAPI) => {
    const { count, ...shelfData } = createShelfData;
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/wms/shelves/?count=${count}`,
        shelfData
      );
      console.log("createShelves", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update shelf +
export const updateShelf = createAsyncThunk(
  "warehouse/updateShelf",
  async (updateData, thunkAPI) => {
    const { id, ...dataToUpdate } = updateData;
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/wms/shelves/${id}`,
        dataToUpdate
      );
      console.log("updateShelf", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete shelf +
export const deleteShelf = createAsyncThunk(
  "warehouse/deleteShelf",
  async (shelfId, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/wms/shelves/${shelfId}`
      );
      console.log("deleteShelf", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create places +
export const createPlaces = createAsyncThunk(
  "warehouse/createPlaces",
  async (createPlacesData, thunkAPI) => {
    const { count, ...placeData } = createPlacesData;
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/wms/places/?count=${count}`,
        placeData
      );
      console.log("createPlaces", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update place +
export const updatePlace = createAsyncThunk(
  "warehouse/updatePlace",
  async (updateData, thunkAPI) => {
    const { id, ...dataToUpdate } = updateData;
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/wms/places/${id}`,
        dataToUpdate
      );
      console.log("updatePlace", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete place +
export const deletePlace = createAsyncThunk(
  "warehouse/deletePlace",
  async (placeId, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/wms/places/${placeId}`
      );
      console.log("deletePlace", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! PARTS

// Add parts to warehouse +
export const addPartsToWarehouse = createAsyncThunk(
  "warehouse/addPartsToWarehouse",
  async (addPartsData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/wms/inventory/add`,
        addPartsData
      );
      console.log("addPartsToWarehouse", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update part +
export const updatePart = createAsyncThunk(
  "warehouse/updatePart",
  async (updateData, thunkAPI) => {
    const { id, ...fields } = updateData;
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/parts/${id}`,
        fields
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail,
      });
    }
  }
);

// Upload prats from excel template +
export const uploadPartsFromExcel = createAsyncThunk(
  "warehouse/uploadPartsFromExcel",
  async (formData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/wms/inventory/parse`,
        formData
      );
      console.log("uploadPartsFromExcel", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// get parts upload history +
export const getPartsUploadHistory = createAsyncThunk(
  "warehouse/getPartsUploadHistory",
  async ({ limit = 50, offset = 0 } = {}, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/wms/inventory/history`,
        { params: { limit, offset } }
      );
      console.log("getPartsUploadHistory", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);
